import React, { useRef, useState } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { OrbitControls, useGLTF } from "@react-three/drei";
import { motion } from "framer-motion";
import * as THREE from "three";

const Model = () => {
  const { scene } = useGLTF("/models/decimic.glb");
  // const meshRef = useRef();

  // useFrame(() => {
  //   // Add shimmer/rotate effect
  //   if (meshRef.current) {
  //     meshRef.current.rotation.y += 0.002;
  //   }
  // });

  return (
    <primitive
      // ref={meshRef}
      object={scene}
      scale={0.8}
      position={[0.5, -1, 0]}
      rotation={[0, 0, 0]}
    />
  );
};

const AnimatedCameraControls = () => {
  const cameraRef = useRef();
  const [zoomDirection, setZoomDirection] = useState(1);
  const [panDirection, setPanDirection] = useState(1);

  useFrame(({ camera }) => {
    camera.position.z += zoomDirection * 0.005;
    if (camera.position.z > 5 || camera.position.z < 1) {
      setZoomDirection(-zoomDirection);
    }

    camera.position.x += panDirection * 0.005;
    if (camera.position.x > 0.5 || camera.position.x < -0.5) {
      setPanDirection(-panDirection);
    }

    camera.lookAt(0, 0, 0);
  });

  return (
    <OrbitControls
      ref={cameraRef}
      enableZoom={false}
      maxDistance={20}
      minDistance={1}
      autoRotate={false}
      maxPolarAngle={Math.PI / 2}
      minPolarAngle={Math.PI / 2}
      maxAzimuthAngle={Math.PI / 4}
      minAzimuthAngle={-Math.PI / 4}
    />
  );
};

const RotatingLight = () => {
  const lightRef = useRef();
  useFrame(({ clock }) => {
    const t = clock.getElapsedTime();
    const radius = 5;
    const speed = 0.5; // adjust for speed
    if (lightRef.current) {
      lightRef.current.position.x = Math.cos(t * speed) * radius;
      lightRef.current.position.z = Math.sin(t * speed) * radius;
      lightRef.current.position.y = 2;
    }
  });
  return <pointLight ref={lightRef} intensity={2} color={"#4fc3f7"} />;
};

const AnimatedSpotLight = () => {
  const lightRef = useRef();
  const targetRef = useRef();

  useFrame(({ clock }) => {
    const t = clock.getElapsedTime();
    const radius = 6;

    // Rotate around the model in a circle
    const x = radius * Math.cos(t);
    const z = radius * Math.sin(t);

    if (lightRef.current && targetRef.current) {
      lightRef.current.position.set(x, 6, z);
      lightRef.current.target.position.set(0, 0, 0);
      lightRef.current.target.updateMatrixWorld();
    }
  });

  return (
    <>
      <spotLight
        ref={lightRef}
        angle={0.4}
        penumbra={0.5}
        intensity={1.8}
        distance={15}
        castShadow
        color="#00cfff"
      />
      <primitive ref={targetRef} object={new THREE.Object3D()} />
    </>
  );
};

const Banner = () => {
  return (
    <section id="top-banner">
      <div className="mx-auto flex flex-col lg:flex-row items-center gap-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          whileHover={{ scale: 1.03 }}
          className="relative w-full sm:h-[250px] md:h-[400px] lg:h-[500px] xl:h-[600px] rounded-xl overflow-hidden shadow-2xl border border-white/10 group"
        >
          <div className="absolute z-10 inset-0 pointer-events-none" />
          <Canvas
            shadows
            camera={{ position: [0, 0, 8], fov: 70 }}
            className="absolute inset-0 w-full h-full"
          >
            <ambientLight intensity={0.6} />
            <pointLight position={[10, 10, 10]} />
            <RotatingLight />
            <AnimatedSpotLight />
            <Model />
            <AnimatedCameraControls />
          </Canvas>
        </motion.div>
      </div>
    </section>
  );
};

export default Banner;
